import React, { useState, useEffect, useMemo } from "react";
import {
  post_googleprop_data,
  disconnect_google,
  post_selected_googleprop,
  post_userpostanalytics,
  getanalyticsdata,
  getsavegoogleoauth,
  postgooglepropertydata,
  postgoogleaccount,
  POST_GOOGLE_LOGIN_ACC,
  POST_GOOGLE_SAVE_ACC,
} from "../services/constants";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ToolTip from "../Mycomponent/share/components/tooltip";
import googleImg from "../Mycomponent/Assets/google-analytics/google.png";
import { DottLoader } from "../Mycomponent/share/loader";
import AlertPopUp from "../Mycomponent/share/components/alert.component";
import { ZustandStore } from "../store/zustand-store";
import AddIcon from "@mui/icons-material/Add";
import useDebouncedFunction from "../helperJs/debounce";
import { getDomainNameAndLang } from "../helperJs/getCountryFlag";
import backIcon from "../Mycomponent/Assets/common/back.svg";

import Wizard from "@semcore/wizard";
import { Flex } from "@semcore/flex-box";
import { Text } from "@semcore/typography";

import Input from "@semcore/ui/input";
import CloseM from "@semcore/ui/icon/Close/m";
import SearchM from "@semcore/ui/icon/Search/m";
import { ButtonLink } from "@semcore/ui/button";
import SemButton from "../common/components/Button";

const GoogleAuth = ({ analyticShow }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = location;
  const queryParams = new URLSearchParams(location.search);
  const websiteurl = useSelector((state) => state.websiteurl);
  const domain = getDomainNameAndLang(websiteurl);
  const domainName = domain?.domain;
  const loading = useSelector((state) => state.loading);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [Error, setError] = React.useState("");
  const [googleProperty, setGoogleProperty] = React.useState({
    data: [],
    loading: true,
  });
  const [Loader, setLoader] = React.useState(false);
  const [selectedGoogleProperty, setselectedGoogleProperty] = React.useState(
    []
  );
  const [buttonLoader, setButtonLoader] = useState(false);
  const [Alert, setAlert] = useState({
    type: "",
    message: "",
    show: false,
  });
  const userAnalyticData = useSelector((state) => state.userAnalyticData);
  const userAnalyticLogin = useSelector((state) => state.userAnalyticLogin);
  const email = localStorage.getItem("admin_mail");
  const google_anayltic_code = queryParams.get("code");
  const [accSelect, setAccSelect] = React.useState([]);
  const [switchAcc, setSwitchAcc] = useState(0);
  const [selectAcc, setSelectAcc] = useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  function handleClose() {
    setAnchorEl(false);
  }

  const getAnalyticsDataByApi = async (api) => {
    return await axios
      .get(api)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return [];
      });
  };

  const getConfig = {
    email: email,
    domain_name: domainName,
  };

  const handleGetAnalyticsData = async () => {
    const api = getanalyticsdata(getConfig);
    return await getAnalyticsDataByApi(api);
  };

  const handleGetSaveGoogleOauth = async () => {
    const api = getsavegoogleoauth(getConfig);
    return await getAnalyticsDataByApi(api);
  };

  const handleUserAnalyticData = async () => {
    if (email == null) return;
    if (userAnalyticData?.length > 0) return;
    const analyticData = await handleGetAnalyticsData();
    if (analyticData?.length === 0) {
      const getSaveGoogleOauth = await handleGetSaveGoogleOauth();
      if (getSaveGoogleOauth?.length > 0) {
        dispatch({ type: "USERANALYTICLOGIN", payload: true });
        dispatch({ type: "USERANALYTICDATA", payload: [] });
      } else {
        axios.post(postgoogleaccount(email, domainName)).then((response) => {
          if (response.data?.length > 0) {
            setData(response.data);
            setAnchorEl(true);
            setLoader(false);
          } else {
            dispatch({ type: "USERANALYTICLOGIN", payload: false });
            dispatch({ type: "USERANALYTICDATA", payload: [] });
          }
        });
      }
    } else if (analyticData?.length > 0) {
      dispatch({ type: "USERANALYTICDATA", payload: analyticData });
      dispatch({ type: "USERANALYTICLOGIN", payload: true });
    }
  };

  useEffect(() => {
    const dominUpdate = () => {
      setAnchorEl(false);
      setData([]);
      setselectedGoogleProperty([]);
      setGoogleProperty([]);
    };
    dominUpdate();
  }, [domainName]);

  const checkUserAnalyticData = async () => {
    if (email == null) return;
    if (userAnalyticData?.length > 0) return;
    const analyticData = await handleGetAnalyticsData();
    const getSaveGoogleOauth = await handleGetSaveGoogleOauth();
    ZustandStore.setState({
      property_name: getSaveGoogleOauth || [],
    });
    if (analyticData?.length === 0) {
      if (getSaveGoogleOauth?.length > 0) {
        dispatch({ type: "USERANALYTICLOGIN", payload: true });
        dispatch({ type: "USERANALYTICDATA", payload: [] });
      }
      setLoader(false);
    } else if (analyticData?.length > 0) {
      dispatch({ type: "USERANALYTICDATA", payload: analyticData });
      dispatch({ type: "USERANALYTICLOGIN", payload: true });
      setLoader(false);
    }
  };

  const debouncedCheckUserAnalyticData = useDebouncedFunction(() => {
    checkUserAnalyticData();
  }, 2000);

  useEffect(() => {
    if (userAnalyticData?.length === 0) {
      setLoader(true);
      debouncedCheckUserAnalyticData(email);
      const interval = 60000 * 2; // 60000 milliseconds = 1 minute
      const intervalId = setInterval(() => {
        debouncedCheckUserAnalyticData(email);
      }, interval);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [email, userAnalyticData, userAnalyticLogin]);

  const postGooglePropertyData = (config) => {
    axios
      .post(postgooglepropertydata(config))
      .then((response) => {
        setGoogleProperty({
          data: response.data,
          loading: false,
        });
      })
      .catch((error) => console.log(error));
  };

  const post_googleAnalytic_code = (config) => {
    navigate(pathname, { replace: true });
    axios
      .post(post_googleprop_data(config))
      .then((response) => {
        setData(response.data);
        setAnchorEl(true);
      })
      .catch(() => {
        setAlert({
          type: "error",
          message: "Error: Google Account Not Connected",
          show: true,
        });
      });
  };

  useEffect(() => {
    if (
      google_anayltic_code != null &&
      email != null &&
      !loading &&
      domainName
    ) {
      const config = {
        code: google_anayltic_code,
        email: email,
        domain: domainName,
      };
      post_googleAnalytic_code(config);
    }
  }, [google_anayltic_code, email, loading, domainName]);

  const handleCloseSelAcc = () => {
    setAccSelect([]);
    setError("");
    setSwitchAcc(0);
    setSelectAcc(false);
  };

  const handleButtonClick = () => {
    setLoader(true);
    setData([]);
    axios
      .post(POST_GOOGLE_LOGIN_ACC(email))
      .then((response) => {
        if (response.data?.length > 0) {
          const groupedByToken = Object.values(
            response?.data?.reduce((acc, item) => {
              if (!acc[item.refresh_token]) {
                acc[item.refresh_token] = [];
              }
              acc[item.refresh_token].push(item);
              return acc;
            }, {})
          );
          setAccSelect(groupedByToken);
          setLoader(false);
        } else {
          axios.post(postgoogleaccount(email, domainName)).then((response) => {
            if (response.data?.length === 0) {
              setLoader(false);
              window.oauth2SignIn();
            } else {
              handleUserAnalyticData();
            }
          });
        }
      })
      .catch(() => {});
  };

  const handleGooglePropertyData = (item) => {
    const config = {
      account_id: item.account_id,
      property_id: item.property_id,
      date: item?.date,
      refresh_token: item.refresh_token,
      email: email,
      domain_name: domainName,
      display_name: item?.property_name,
    };
    const config2 = {
      property_id: item.property_id,
      date: item?.date,
      refresh_token: item.refresh_token,
      email: email,
      domain_name: domainName,
      display_name: item?.property_name,
    };

    axios
      .post(post_selected_googleprop(config))
      .then(() => {
        handleCloseSelAcc();
        setAnchorEl(false);
        setData([]);
        dispatch({ type: "USERANALYTICLOGIN", payload: true });
        axios.post(post_userpostanalytics(config2));
      })
      .catch((error) => console.log(error));
  };

  const handleDisconnectGoogle = () => {
    if (email == null) return;
    setButtonLoader(true);
    axios
      .post(disconnect_google(getConfig))
      .then(() => {
        dispatch({ type: "USERANALYTICLOGIN", payload: false });
        dispatch({ type: "USERANALYTICDATA", payload: [] });
        setButtonLoader(true);
      })
      .catch(() => {
        setButtonLoader(false);
        setAlert({
          type: "error",
          message: "Error: Google Account Not Disconnected",
          show: true,
        });
      });
  };

  const handleGoogleAnaltyicAccountId = (type, value, index) => {
    const data = {
      id: index,
      account_id: value?.account_id,
      account_name: value?.account_name,
      property_id: "",
      property_name: "",
      date: "",
      refresh_token: value?.refresh_token,
      email: email,
    };
    setSearchQuery("");
    if (type === "Account") {
      setGoogleProperty({
        data: [],
        loading: true,
      });
      setselectedGoogleProperty(data);
      postGooglePropertyData(data);
    } else if (type === "Select") {
      setselectedGoogleProperty(data);
    } else {
      setselectedGoogleProperty({
        ...selectedGoogleProperty,
        property_id: value?.name,
        property_name: value?.displayName,
        date: value?.createTime,
      });
    }
  };

  const handleSubmitGoogleProperty = () => {
    if (selectedGoogleProperty?.length === 0) {
      setError("Please, Select Account");
    } else if (selectedGoogleProperty?.property_id === "") {
      setError("Please, Select Property");
    } else {
      setError("");
      handleGooglePropertyData(selectedGoogleProperty);
    }
  };

  const Sppiner = () => {
    return (
      <Box
        sx={{ display: "flex", minHeight: 350, minWidth: 350 }}
        className="w-100 h-100 cad"
      >
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only"></span>
        </div>
      </Box>
    );
  };

  const handleSwitchAcc = () => {
    setError("");
    setSwitchAcc((prevIndex) => (prevIndex + 1) % accSelect?.length || 0);
  };

  const handleAddAcc = () => {
    handleCloseSelAcc();
    setData([]);
    setLoader(true);
    axios
      .post(postgoogleaccount(email, domainName))
      .then((response) => {
        if (response.data?.length === 0) {
          setLoader(false);
          window.oauth2SignIn();
        } else {
          handleUserAnalyticData();
        }
      })
      .catch(() => {});
  };

  const handleSaveSelAcc = (item) => {
    const itemData = encodeURIComponent(JSON.stringify(item));
    const config = {
      email: email,
      domain: domainName,
      data: itemData,
      refresh_token: item?.[0]?.refresh_token,
    };
    axios
      .post(POST_GOOGLE_SAVE_ACC(config))
      .then((response) => {})
      .catch(() => {});
  };

  const googleAccList = useMemo(() => {
    if (data?.length > 0) return data;
    return accSelect?.[switchAcc] || [];
  }, [accSelect, switchAcc, data]);

  // Filtered list with single search input
  const filteredGoogleAccList = useMemo(() => {
    if (!searchQuery.trim()) return googleAccList;
    const lowerSearch = searchQuery.toLowerCase();
    return googleAccList.filter((acc) => {
      return (
        acc.account_id.includes(searchQuery) ||
        acc.account_name.toLowerCase().includes(lowerSearch)
      );
    });
  }, [googleAccList, searchQuery]);

  // Filtered list with single search input
  const filteredGoogleProList = useMemo(() => {
    const proList = googleProperty?.data?.[0]?.final_res?.properties || [];
    if (!searchQuery.trim()) return proList;
    const lowerSearch = searchQuery.toLowerCase();
    return proList.filter((acc) => {
      return (
        acc.name.includes(searchQuery) ||
        acc.displayName.toLowerCase().includes(lowerSearch)
      );
    });
  }, [googleProperty?.data, searchQuery]);

  return (
    <>
      {Loader && <DottLoader />}
      <AlertPopUp config={Alert} handleClose={setAlert} />
      {userAnalyticLogin ? (
        <>
          {analyticShow ? (
            <button
              onClick={() => handleDisconnectGoogle()}
              className="google-login-btn d-flex align-items-center"
            >
              {buttonLoader ? (
                <Box
                  sx={{ display: "flex", minHeight: 8, minWidth: 8 }}
                  className="w-100 h-100 cad"
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only"></span>
                  </div>
                </Box>
              ) : (
                <>
                  <img
                    src={googleImg}
                    alt=""
                    className=""
                    style={{
                      width: "18px",
                      height: "18px",
                      marginRight: "10px",
                    }}
                  />
                  Disconnect with Google
                </>
              )}
            </button>
          ) : null}
        </>
      ) : (
        <button
          onClick={handleButtonClick}
          style={{ background: "white", color: "black" }}
          className="google-login-btn d-flex align-items-center"
          disabled={Loader}
        >
          <img
            src={googleImg}
            alt=""
            className=""
            style={{ width: "18px", height: "18px", marginRight: "12px" }}
          />
          Connect with Google
        </button>
      )}

      <Wizard
        visible={accSelect?.length > 0}
        step={1}
        w={"90%"}
        h={"550px"}
        wMax={"800px"}
        onClose={handleCloseSelAcc}
        className="add-google-acc-popup"
        key={"add-google-acc-popup"}
      >
        <Wizard.Sidebar title="Select Google Account" w={"25%"}>
          {selectedGoogleProperty?.account_name && (
            <Box className="selected-acc">
              <Text>{selectedGoogleProperty.account_name}</Text>
              <Text>{selectedGoogleProperty.account_id}</Text>
            </Box>
          )}
        </Wizard.Sidebar>
        <Wizard.Content tag={Flex} direction="column" w={"75%"} p={4}>
          <Wizard.Step step={1}>
            <Box className="mt-4">
              <Input w={320} h={35}>
                <Input.Value
                  placeholder="Search account here"
                  value={searchQuery}
                  onChange={(v) => setSearchQuery(v)}
                  id="clear-example"
                />
                <Input.Addon>
                  {searchQuery ? (
                    <ButtonLink
                      use="secondary"
                      addonLeft={CloseM}
                      title="Clear"
                      onClick={() => setSearchQuery("")}
                    />
                  ) : (
                    <SearchM />
                  )}
                </Input.Addon>
              </Input>
              <Grid container spacing={2} columns={12}>
                {selectAcc ? (
                  <Grid item xs={12}>
                    {googleProperty.loading ? (
                      <Sppiner />
                    ) : googleProperty?.data?.length === 0 ? (
                      <Box
                        sx={{ display: "flex", minHeight: 300 }}
                        className="cad"
                      >
                        <h1 className="heading-small font-bold popover-list-header">
                          {selectedGoogleProperty?.length === 0
                            ? "Select your Account to see property list."
                            : "No properties found for the selected account."}
                        </h1>
                      </Box>
                    ) : (
                      <>
                        <Flex gap={2} mt={4}>
                          <Text fontWeight={600} size={400} mb={0} mr={"auto"}>
                            Select Property
                            <ToolTip
                              title="List of Properties attached with your Google Analyics
                            Account, select property for which you want data to be
                            shown."
                            />
                          </Text>
                        </Flex>
                        <List
                          component="nav"
                          aria-label="select-google-property"
                          className="overflow-auto p-0 list-border h-100"
                          sx={{ maxHeight: 350, minHeight: 220 }}
                        >
                          {filteredGoogleProList?.length === 0 ? (
                            <span className="heading-small font-light-bold d-flex align-items-center w-100 h-100 justify-content-center">
                              {searchQuery
                                ? "No Properties Found"
                                : "No Properties"}
                            </span>
                          ) : (
                            filteredGoogleProList?.map((item, index) => {
                              return (
                                <React.Fragment
                                  key={`google-property-list${index}`}
                                >
                                  <ListItemButton
                                    selected={
                                      selectedGoogleProperty?.property_id ===
                                      item?.name
                                    }
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          "rgba(240, 242, 255, 1)",
                                      },
                                    }}
                                    onClick={() =>
                                      handleGoogleAnaltyicAccountId(
                                        "Property",
                                        item
                                      )
                                    }
                                  >
                                    <ListItemText
                                      primary={item?.displayName}
                                      secondary={item?.name}
                                      sx={{
                                        "& .MuiListItemText-primary": {
                                          fontSize: "1.2em",
                                          color: "#365486",
                                          fontWeight: "600",
                                        },
                                        "& .MuiListItemText-secondary": {
                                          fontSize: "1em",
                                          color: "black",
                                        },
                                      }}
                                    />
                                  </ListItemButton>
                                  <Divider />
                                </React.Fragment>
                              );
                            })
                          )}
                        </List>
                      </>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Flex gap={2} mt={4} flexWrap={"wrap"} alignItems="center">
                      <Text fontWeight={600} size={400} mb={0} mr={"auto"}>
                        Select Account
                      </Text>
                      {selectAcc ? null : (
                        <>
                          <SemButton
                            name="Switch Account"
                            title="For switching Connected Google Accounts."
                            disabled={accSelect?.length === 1}
                            onClick={() => handleSwitchAcc((pre) => pre + 1)}
                          />
                          <SemButton
                            name="Add Account"
                            title="Add Account"
                            icon={<AddIcon fontSize="small" />}
                            onClick={() => handleAddAcc()}
                          />
                        </>
                      )}
                    </Flex>
                    <List
                      component="nav"
                      aria-label="select-google-property"
                      className="overflow-auto p-0 list-border h-100 mt-2"
                      sx={{ maxHeight: 350, minHeight: 220 }}
                    >
                      {filteredGoogleAccList?.length === 0 ? (
                        <span className="heading-small font-light-bold d-flex align-items-center w-100 h-100 justify-content-center">
                          {searchQuery ? "No Account Found" : "No Account"}
                        </span>
                      ) : (
                        filteredGoogleAccList?.map((item, index) => {
                          return (
                            <React.Fragment key={`select-acc-${index}`}>
                              <ListItemButton
                                selected={
                                  selectedGoogleProperty?.account_id ===
                                  item?.account_id
                                }
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "rgba(240, 242, 255, 1)",
                                  },
                                }}
                                onClick={() => {
                                  setSelectAcc(true);
                                  handleSaveSelAcc(accSelect?.[switchAcc]);
                                  handleGoogleAnaltyicAccountId(
                                    "Account",
                                    item
                                  );
                                }}
                              >
                                <ListItemText
                                  primary={`${item?.account_name}`}
                                  secondary={item?.account_id}
                                  sx={{
                                    "& .MuiListItemText-primary": {
                                      fontSize: "1.2em",
                                      color: "#365486",
                                      fontWeight: "600",
                                    },
                                    "& .MuiListItemText-secondary": {
                                      fontSize: "1em",
                                      color: "black",
                                    },
                                  }}
                                />
                              </ListItemButton>
                            </React.Fragment>
                          );
                        })
                      )}
                    </List>
                  </Grid>
                )}
              </Grid>
              {Error && (
                <span className="msg-error w-100 d-flex justify-content-center">
                  {Error}
                </span>
              )}{" "}
              {selectAcc && (
                <>
                  <Divider />
                  <Box className="pt-2 justify-content-end d-flex align-items-center gap-2 flex-wrap">
                    <SemButton
                      name="Back"
                      title="Back"
                      icon={<img src={backIcon} alt="back" />}
                      onClick={() => setSelectAcc(false)}
                    />
                    <SemButton
                      name="Submit"
                      title="Submit"
                      onClick={() => handleSubmitGoogleProperty()}
                    />
                  </Box>
                </>
              )}
            </Box>
          </Wizard.Step>
        </Wizard.Content>
      </Wizard>
      <Wizard
        visible={anchorEl}
        step={1}
        w={"90%"}
        h={"550px"}
        wMax={"800px"}
        onClose={handleClose}
        className="add-google-acc-popup"
        key={"sel-google-acc-popup"}
      >
        <Wizard.Sidebar title="Select Google Property" w={"25%"}>
          {selectedGoogleProperty?.account_name && (
            <Box className="selected-acc">
              <Text>{selectedGoogleProperty.account_name}</Text>
              <Text>{selectedGoogleProperty.account_id}</Text>
            </Box>
          )}
        </Wizard.Sidebar>
        <Wizard.Content tag={Flex} direction="column" w={"75%"} p={4}>
          <Wizard.Step step={1}>
            {data?.length > 0 ? (
              <Box className="mt-4">
                <Input w={320} h={35}>
                  <Input.Value
                    placeholder="Search account here"
                    value={searchQuery}
                    onChange={(v) => setSearchQuery(v)}
                    id="clear-example"
                  />
                  <Input.Addon>
                    {searchQuery ? (
                      <ButtonLink
                        use="secondary"
                        addonLeft={CloseM}
                        title="Clear"
                        onClick={() => setSearchQuery("")}
                      />
                    ) : (
                      <SearchM />
                    )}
                  </Input.Addon>
                </Input>
                <Grid container spacing={2} columns={12} className="my-3">
                  {selectAcc ? (
                    <Grid item xs={12}>
                      {googleProperty.loading ? (
                        <Sppiner />
                      ) : googleProperty?.data?.length === 0 ? (
                        <Box
                          sx={{ display: "flex", minHeight: 300 }}
                          className="cad"
                        >
                          <h1 className="heading-small font-bold popover-list-header">
                            {selectedGoogleProperty?.length === 0
                              ? "Select your Account to see property list."
                              : "No properties found for the selected account."}
                          </h1>
                        </Box>
                      ) : (
                        <>
                          <Flex gap={2}>
                            <Text
                              fontWeight={600}
                              size={400}
                              mb={0}
                              mr={"auto"}
                            >
                              Select Property
                              <ToolTip
                                title="List of Properties attached with your Google Analyics
                            Account, select property for which you want data to be
                            shown."
                              />
                            </Text>
                          </Flex>
                          <List
                            component="nav"
                            aria-label="select-google-property"
                            className="overflow-auto p-0 list-border h-100"
                            sx={{ maxHeight: 350 }}
                          >
                            {filteredGoogleProList?.length === 0 ? (
                              <span className="heading-small font-light-bold d-flex align-items-center w-100 h-100 justify-content-center">
                                {searchQuery
                                  ? "No Properties Found"
                                  : "No Properties"}
                              </span>
                            ) : (
                              filteredGoogleProList?.map((item, index) => {
                                return (
                                  <React.Fragment
                                    key={`google-property-list${index}`}
                                  >
                                    <ListItemButton
                                      selected={
                                        selectedGoogleProperty?.property_id ===
                                        item?.name
                                      }
                                      sx={{
                                        "&:hover": {
                                          backgroundColor:
                                            "rgba(240, 242, 255, 1)",
                                        },
                                      }}
                                      onClick={() =>
                                        handleGoogleAnaltyicAccountId(
                                          "Property",
                                          item
                                        )
                                      }
                                    >
                                      <ListItemText
                                        primary={item?.displayName}
                                        secondary={item?.name}
                                        sx={{
                                          "& .MuiListItemText-primary": {
                                            fontSize: "1.2em",
                                            color: "#365486",
                                            fontWeight: "600",
                                          },
                                          "& .MuiListItemText-secondary": {
                                            fontSize: "1em",
                                            color: "black",
                                          },
                                        }}
                                      />
                                    </ListItemButton>
                                    <Divider />
                                  </React.Fragment>
                                );
                              })
                            )}
                          </List>
                        </>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <>
                        <Text fontWeight={600} size={400} mb={0} mr={"auto"}>
                          Select Account
                        </Text>
                        <List
                          component="nav"
                          aria-label="select-google-property"
                          className="overflow-auto p-0 list-border h-100"
                          sx={{ maxHeight: 350 }}
                        >
                          {filteredGoogleAccList?.length === 0 ? (
                            <span className="heading-small font-light-bold d-flex align-items-center w-100 h-100 justify-content-center">
                              {searchQuery ? "No Account Found" : "No Account"}
                            </span>
                          ) : (
                            filteredGoogleAccList?.map((item, index) => {
                              return (
                                <React.Fragment
                                  key={`google-property-list${index}`}
                                >
                                  <ListItemButton
                                    selected={
                                      selectedGoogleProperty?.account_id ===
                                      item?.account_id
                                    }
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          "rgba(240, 242, 255, 1)",
                                      },
                                    }}
                                    onClick={() => {
                                      setSelectAcc(true);
                                      handleGoogleAnaltyicAccountId(
                                        "Account",
                                        item
                                      );
                                    }}
                                  >
                                    <ListItemText
                                      primary={item?.account_name}
                                      secondary={item?.account_id}
                                      sx={{
                                        "& .MuiListItemText-primary": {
                                          fontSize: "1.2em",
                                          color: "#365486",
                                          fontWeight: "600",
                                        },
                                        "& .MuiListItemText-secondary": {
                                          fontSize: "1em",
                                          color: "black",
                                        },
                                      }}
                                    />
                                  </ListItemButton>
                                  <Divider />
                                </React.Fragment>
                              );
                            })
                          )}
                        </List>
                      </>
                    </Grid>
                  )}
                </Grid>
                {Error && (
                  <span className="msg-error w-100 d-flex justify-content-center">
                    {Error}
                  </span>
                )}
                <Divider />
                <Box className="pt-2 justify-content-end d-flex align-items-center gap-2 flex-wrap">
                  <SemButton
                    name="Back"
                    title="Back"
                    icon={<img src={backIcon} alt="back" />}
                    onClick={() => setSelectAcc(false)}
                    disabled={!selectAcc}
                  />
                  <SemButton
                    name="Submit"
                    title="Submit"
                    onClick={() => handleSubmitGoogleProperty()}
                  />
                </Box>
              </Box>
            ) : (
              <div
                className="d-flex align-items-center justify-content-center w-100 h-100"
                style={{
                  minHeight: "180px",
                  flexDirection: "column",
                  padding: "0 40px",
                }}
              >
                <p className="mb-0 msg-error">
                  There is no Google Property added in this account.
                </p>
                <p className="mb-0 msg-error">Please check your account.</p>
              </div>
            )}
          </Wizard.Step>
        </Wizard.Content>
      </Wizard>
    </>
  );
};

export default GoogleAuth;
